import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingAccountComponent } from './customer/billing-account/billing-account.component';
import { CommunicationsComponent } from './communications/communications.component';
import { ContactlistsComponent } from './customer/contactlists/contactlists.component';
import { CustomersComponent } from './customers.component';
import { FinancialAccountComponent } from './customer/financial-account/financial-account.component';
import { IdentificationsComponent } from './customer/identifications/identifications.component';
import { OrdersComponent } from './customer/orders/orders.component';
import { ProfileComponent } from './customer/profile/profile.component';
import { QuotesComponent } from './customer/quotes/quotes.component';
import { RelationshipsComponent } from './customer/relationships/relationships.component';
import { RequestsComponent } from './customer/requests/requests.component';
import { ShoppinglistsComponent } from './shoppinglists/shoppinglists.component';
import { CustomerRoutingModule } from './customer-routing.module';
import { CustomerComponent } from './customer/customer.component';
import { CustomerCommunicationsComponent } from './customer/customer-communications/customer-communications.component';
import { UbsViewContainersModule } from '@urbannex/view-containers';
import { NbCardModule } from '@nebular/theme';
import { CustomerBasicInfoComponent } from './customer/customer-basic-info/customer-basic-info.component';
import { CustomerContactsComponent } from './customer/profile/customer-contacts/customer-contacts.component';
import { CustomerPaymentInfoComponent } from './customer/profile/customer-payment-info/customer-payment-info.component';
import { CustomerLoyaltyComponent } from './customer/profile/customer-loyalty/customer-loyalty.component';
import { CustomerIdentificationComponent } from './customer/profile/customer-identification/customer-identification.component';
import { CustomerContentComponent } from './customer/profile/customer-content/customer-content.component';
import { CustomerNotesComponent } from './customer/profile/customer-notes/customer-notes.component';
import { OfbizFormsModule } from '@urbannex/ofbiz-forms';
import { CutomerPostalComponent } from './customer/profile/customer-contacts/cutomer-postal/cutomer-postal.component';
import { CutomerTelecomComponent } from './customer/profile/customer-contacts/cutomer-telecom/cutomer-telecom.component';
import { CutomerEmailComponent } from './customer/profile/customer-contacts/cutomer-email/cutomer-email.component';
import { CustomerCreditCardComponent } from './customer/profile/customer-payment-info/customer-credit-card/customer-credit-card.component';
import { CustomerChequeAccountComponent } from './customer/profile/customer-payment-info/customer-cheque-account/customer-cheque-account.component';
import { CustomerEftAccountComponent } from './customer/profile/customer-payment-info/customer-eft-account/customer-eft-account.component';
import { CustomerBillingAccountComponent } from './customer/profile/customer-payment-info/customer-billing-account/customer-billing-account.component';



@NgModule({
  declarations: [
    CustomersComponent,
    IdentificationsComponent,
    ProfileComponent,
    RelationshipsComponent,
    ShoppinglistsComponent,
    ContactlistsComponent,
    BillingAccountComponent,
    FinancialAccountComponent,
    CommunicationsComponent,
    RequestsComponent,
    QuotesComponent,
    OrdersComponent,
    CustomerComponent,
    CustomerCommunicationsComponent,
    CustomerBasicInfoComponent,
    CustomerContactsComponent,
    CustomerPaymentInfoComponent,
    CustomerLoyaltyComponent,
    CustomerIdentificationComponent,
    CustomerContentComponent,
    CustomerNotesComponent,
    CutomerPostalComponent,
    CutomerTelecomComponent,
    CutomerEmailComponent,
    CustomerCreditCardComponent,
    CustomerChequeAccountComponent,
    CustomerEftAccountComponent,
    CustomerBillingAccountComponent
  ],
  imports: [
    CommonModule,
    NbCardModule,
    UbsViewContainersModule,
    CustomerRoutingModule,
    OfbizFormsModule
  ]
})
export class CustomerModule { }
